export default __webpack_public_path__ + "static/media/graphics-id-verfication-id-verification-error.c1f0cd3e.svg";